function _assert(predicate: unknown, message?: string): asserts predicate {
    if (!predicate) {
        throw new Error(message ?? 'Assertion failed');
    }
}

function isNotNull<T>(value: T | null, message?: string): asserts value is T {
    if (value === null) {
        throw new Error(message ?? 'Value is null');
    }
}

function isNotUndefined<T>(
    value: T | undefined,
    message?: string,
): asserts value is T {
    if (value === undefined) {
        throw new Error(message ?? 'Value is undefined');
    }
}

function isString(value: unknown, message?: string): asserts value is string {
    if (typeof value !== 'string') {
        throw new Error(message ?? 'Value is not a string');
    }
}

function isOneOf<T, const Allowed extends ReadonlyArray<T>>(
    value: T,
    allowedValues: Allowed,
    message?: string,
): asserts value is Allowed[number] {
    if (!allowedValues.includes(value)) {
        throw new Error(
            message ??
                `Value ${JSON.stringify(value)} is not in [${allowedValues.join(', ')}]`,
        );
    }
}

function strictEqual<T, Expected extends T>(
    value: T,
    expected: Expected,
    message?: string,
): asserts value is Expected {
    if (value !== expected) {
        throw new Error(
            message ??
                `Expected ${JSON.stringify(value)} to strictly equal ${JSON.stringify(expected)}`,
        );
    }
}

function never(value: never, message?: string): never {
    throw new Error(
        message ??
            `Unexpected value: ${JSON.stringify(value)}; this codepath should never be reached.`,
    );
}

function fail(message: string): never {
    throw new Error(message);
}

function IsTrueType<T extends true>() {}

export const assert: typeof _assert & {
    isNotNull: typeof isNotNull;
    isNotUndefined: typeof isNotUndefined;
    isString: typeof isString;
    isOneOf: typeof isOneOf;
    strictEqual: typeof strictEqual;
    never: typeof never;
    fail: typeof fail;
    IsTrueType: typeof IsTrueType;
} = Object.assign(_assert, {
    isNotNull,
    isNotUndefined,
    isString,
    isOneOf,
    strictEqual,
    never,
    IsTrueType,
    fail,
});
